import { render } from "./VerticalNavMenuItems.vue?vue&type=template&id=3f6e1388"
import script from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
script.render = render

export default script